import Cookies from 'js-cookie';

export const SavePatientDefaultValues = (gatheredData) => {
  const IdPerson =
    Cookies.get('user') &&
    JSON.parse(Cookies.get('user'))?.IdPerson;

  // console.log('gatheredDatagatheredData--->', gatheredData);

  // console.log('gatheredDatagatheredData-->', gatheredData);

  return {
    FirstName: '',
    LastName: '',
    FatherName: '',
    BirthDate: '',
    NationalCode: '',
    ImageData: '',
    Address: '',
    Telephon: '',
    Mobile: '',
    Email: 'example@example.com',
    Id: Number(gatheredData?.Id) || 0,
    IdGender: '',
    idCityTavalod: '',
    idCitySokonat: '',
    ShomareShenasname: '',
    CodePosti: '',
    TelJob: '',
    idBlodGroup: '',
    idTaahol: '',
    idJob: '',
    idTahsilat: '',
    idMantaghe: '',
    idNahveAshnae: '',
    idReligion: '',
    idUserPerson: IdPerson,
  };
};
